var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08333 3.49992H13.4167C13.5714 3.49992 13.7197 3.43846 13.8291 3.32906C13.9385 3.21967 14 3.07129 14 2.91659C14 2.76188 13.9385 2.6135 13.8291 2.50411C13.7197 2.39471 13.5714 2.33325 13.4167 2.33325H4.08333C3.92862 2.33325 3.78025 2.39471 3.67085 2.50411C3.56146 2.6135 3.5 2.76188 3.5 2.91659C3.5 3.07129 3.56146 3.21967 3.67085 3.32906C3.78025 3.43846 3.92862 3.49992 4.08333 3.49992Z",
    fill: "#586370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 6.41675H4.08333C3.92862 6.41675 3.78025 6.47821 3.67085 6.5876C3.56146 6.697 3.5 6.84537 3.5 7.00008C3.5 7.15479 3.56146 7.30316 3.67085 7.41256C3.78025 7.52196 3.92862 7.58341 4.08333 7.58341H13.4167C13.5714 7.58341 13.7197 7.52196 13.8291 7.41256C13.9385 7.30316 14 7.15479 14 7.00008C14 6.84537 13.9385 6.697 13.8291 6.5876C13.7197 6.47821 13.5714 6.41675 13.4167 6.41675Z",
    fill: "#586370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 10.5H4.08333C3.92862 10.5 3.78025 10.5615 3.67085 10.6709C3.56146 10.7803 3.5 10.9286 3.5 11.0833C3.5 11.238 3.56146 11.3864 3.67085 11.4958C3.78025 11.6052 3.92862 11.6667 4.08333 11.6667H13.4167C13.5714 11.6667 13.7197 11.6052 13.8291 11.4958C13.9385 11.3864 14 11.238 14 11.0833C14 10.9286 13.9385 10.7803 13.8291 10.6709C13.7197 10.5615 13.5714 10.5 13.4167 10.5Z",
    fill: "#586370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 4.08333C1.811 4.08333 2.33333 3.561 2.33333 2.91667C2.33333 2.27233 1.811 1.75 1.16667 1.75C0.522334 1.75 0 2.27233 0 2.91667C0 3.561 0.522334 4.08333 1.16667 4.08333Z",
    fill: "#586370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 8.16659C1.811 8.16659 2.33333 7.64425 2.33333 6.99992C2.33333 6.35559 1.811 5.83325 1.16667 5.83325C0.522334 5.83325 0 6.35559 0 6.99992C0 7.64425 0.522334 8.16659 1.16667 8.16659Z",
    fill: "#586370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 12.2501C1.811 12.2501 2.33333 11.7277 2.33333 11.0834C2.33333 10.4391 1.811 9.91675 1.16667 9.91675C0.522334 9.91675 0 10.4391 0 11.0834C0 11.7277 0.522334 12.2501 1.16667 12.2501Z",
    fill: "#586370"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/listViewIcon.ad47e11b3f0cf61ce4e2320f0a3e2f18.svg";
export { ForwardRef as ReactComponent };